<template>
  <div>
    <Header/>

    <b-container fluid>
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <b-icon icon="graph-up"></b-icon>
          <span>Financieras</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>Fn_financieras</div>
        </b-col>
      </b-row>


        <div class="mt-4">
          <b-tabs content-class="mt-3">
            <b-tab title="Administración de Financieras" active>
              <Financieras/>
            </b-tab>
            <b-tab title="Administración de Financiamientos">
              <ConfiguracionFinanciamiento/>
            </b-tab>
            <b-tab v-if="$localStorageService.can('Config_atrato')" title="Calculadora Atrato">
              <Atrato/>
            </b-tab>
          </b-tabs>
        </div>


    </b-container>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Financieras from "@/views/catalogos/Financiamiento/Financieras";
import ConfiguracionFinanciamiento from "@/views/catalogos/Financiamiento/ConfiguracionFinanciamiento";
import Atrato from "@/views/catalogos/Financiamiento/Atrato";
export default {
  name: "TabsFinanciamiento",
  components: {ConfiguracionFinanciamiento, Financieras,Atrato, Header}
}
</script>

<style scoped>

</style>
